export default "__VITE_ASSET__CRYaRiq0__"